import { areIntervalsOverlapping } from "date-fns";

export const getAvailableRangesForEquipment = ({
  reservationData = [],
  equipmentId,
  startRange,
  endRange,
}) => {
  const rangeStart = new Date(startRange);
  const rangeEnd = new Date(endRange);

  if (rangeStart >= rangeEnd) {
    return [];
  }

  const equipmentReservations = reservationData
    .filter((reservation) => reservation.resource === equipmentId)
    .map((reservation) => ({
      start: new Date(reservation.start),
      end: new Date(reservation.end),
    }))
    .filter(({ start, end }) => end > rangeStart && start < rangeEnd)
    .sort((a, b) => a.start - b.start);

  if (equipmentReservations.length === 0) {
    return [{ start: startRange, end: endRange }];
  }

  const availableRanges = [];
  let cursor = rangeStart;

  equipmentReservations.forEach(({ start, end }) => {
    const boundedStart = start < rangeStart ? rangeStart : start;
    const boundedEnd = end > rangeEnd ? rangeEnd : end;

    if (boundedStart > cursor) {
      availableRanges.push({
        start: cursor.toISOString(),
        end: boundedStart.toISOString(),
      });
    }

    if (boundedEnd > cursor) {
      cursor = boundedEnd;
    }
  });

  if (cursor < rangeEnd) {
    availableRanges.push({
      start: cursor.toISOString(),
      end: rangeEnd.toISOString(),
    });
  }

  return availableRanges;
};

export const hasValidReservationList = (reservationList) => Array.isArray(reservationList);

export const getReservationDataInRange = ({
  reservationList = [],
  startRange,
  endRange,
  currentIsRecurring = false,
}) => {
  if (currentIsRecurring) {
    return [];
  }

  return reservationList.filter((reservation) =>
    areIntervalsOverlapping(
      { start: new Date(startRange), end: new Date(endRange) },
      { start: new Date(reservation.start), end: new Date(reservation.end) }
    )
  );
};

export const getBaseReservationsForEventDetails = ({
  reservationList = [],
  reservationData = [],
  currentIsRecurring = false,
}) => (currentIsRecurring ? reservationList : reservationData);

export const getQuickEditReservations = ({
  baseReservations = [],
  refreshTarget = null,
}) => {
  if (!refreshTarget?.bookingId) {
    return baseReservations;
  }

  return baseReservations.filter((reservation) => {
    const sameBooking = reservation.bookingId === refreshTarget.bookingId || reservation.id === refreshTarget.bookingId;
    const sameResource =
      !refreshTarget.resource ||
      reservation.inventoryId === refreshTarget.resource ||
      reservation.resource === refreshTarget.resource;

    return sameBooking && sameResource;
  });
};

export const getUnreservedIntervalsForEventDetails = ({
  isTimelineView,
  createIntervalsForUnreservedEquipment,
  activeEquipmentList,
  reservationData,
  startRange,
  endRange,
  originalEquipmentIds,
  intervalRowConfiguration,
  includeNewEquipmentInEditMode = false,
}) => {
  if (isTimelineView) {
    return [];
  }

  return createIntervalsForUnreservedEquipment(
    activeEquipmentList,
    reservationData,
    startRange,
    endRange,
    originalEquipmentIds,
    intervalRowConfiguration,
    includeNewEquipmentInEditMode,
  );
};